var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverconvert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10337 10.9458C2.30797 10.9458 0.0419922 8.67978 0.0419922 5.88438C0.0419922 3.08898 2.30797 0.822998 5.10337 0.822998C7.89877 0.822998 10.1648 3.08898 10.1648 5.88438C10.1648 8.67978 7.89877 10.9458 5.10337 10.9458ZM5.10337 9.93348C6.17726 9.93348 7.20717 9.50688 7.96652 8.74753C8.72588 7.98817 9.15248 6.95827 9.15248 5.88438C9.15248 4.81049 8.72588 3.78058 7.96652 3.02123C7.20717 2.26188 6.17726 1.83527 5.10337 1.83527C4.02948 1.83527 2.99958 2.26188 2.24022 3.02123C1.48087 3.78058 1.05427 4.81049 1.05427 5.88438C1.05427 6.95827 1.48087 7.98817 2.24022 8.74753C2.99958 9.50688 4.02948 9.93348 5.10337 9.93348V9.93348ZM2.57268 6.39052H7.12793V7.40279H5.10337V8.92121L2.57268 6.39052ZM5.10337 4.36597V2.84755L7.63406 5.37824H3.07882V4.36597H5.10337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverconvert);
export default __webpack_public_path__ + "static/media/coverconvert.46f7756c07593bf52db8e8749f4363e3.svg";
export { ForwardRef as ReactComponent };